import {Style,  RegularShape, Fill, Stroke} from 'ol/style';
import { asArray as colorAsArray} from 'ol/color';

import { parser as gradientCssParser } from '../../utils/Gradient/parser.js';
import { CanvasGradient } from '../../utils/Gradient/ol.js';

export const regular = async (styleDef,layer,__style) => {

	var __layer = Object.assign({},layer);

	const radius = __layer.radius || styleDef.size/2 * (__layer.ratio || 1);
	const innerRadius = __layer.innerRadius || null;

	const anchor = __layer.anchor || [0.5,0.5]
	const displacement = styleDef.anchor ? [(styleDef.anchor[0] - 0.5)*styleDef.size,(styleDef.anchor[1] - 0.5)*styleDef.size] : [0,0];

	const fill = new Fill();
	if(__layer.fill)
	{
		const gradient = gradientCssParser(__layer.fill, radius*2);
		if(gradient)
		{
			fill.setColor(CanvasGradient(gradient));
		}
		else
		{
			fill.setColor(__layer.fill)
		}
	}

	const regularShapeSettings = {
		displacement:[
			displacement[0] + (0.5 - anchor[0])*2*radius,
			displacement[1] + (anchor[1] - 0.5)*2*radius
		],
		points:__layer.point || 5,
		angle:(Math.PI * __layer.angle/180 || 0),
		fill: fill,
		stroke: __layer.stroke ? new Stroke({ color: __layer.stroke.color, width: __layer.stroke.width }) : null,
	};

	if(innerRadius)
	{
		regularShapeSettings.radius1 = radius;
		regularShapeSettings.radius2 = innerRadius;
	}
	else
	{
		regularShapeSettings.radius = radius;
	}

	const regularShape = new RegularShape(regularShapeSettings);
	regularShape.setOpacity(__layer.opacity || 1);

	__style.push(new Style({
		zIndex: styleDef.zIndex,
		image: regularShape
	}));

	return __style;
};

export  default regular;